import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

// Safe mode: динамический импорт с отловом ошибок
async function bootstrap() {
  const rootEl = document.getElementById("root");
  if (!rootEl) {
    console.error("[bootstrap] #root not found");
    return;
  }

  try {
    // Динамически импортируем App и ErrorBoundary
    const [{ default: App }, { ErrorBoundary }] = await Promise.all([
      import("./App"),
      import("./components/ErrorBoundary"),
    ]);

    createRoot(rootEl).render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );
  } catch (err) {
    // Если импорт упал — показываем ошибку прямо в DOM
    console.error("[bootstrap] Failed to load App:", err);
    
    const errorMsg = err instanceof Error 
      ? `${err.message}\n\n${err.stack || ''}` 
      : String(err);

    rootEl.innerHTML = `
      <div style="padding:32px;font-family:system-ui,sans-serif;background:#1a1a2e;color:#fff;min-height:100vh;">
        <h1 style="color:#ff6b6b;margin:0 0 16px;">❌ Ошибка загрузки приложения</h1>
        <pre style="background:#2d2d44;padding:16px;border-radius:8px;overflow:auto;font-size:13px;color:#eee;white-space:pre-wrap;">${errorMsg.replace(/</g, '&lt;')}</pre>
        <button onclick="location.reload()" style="margin-top:24px;padding:12px 24px;background:#4ecdc4;color:#000;border:none;border-radius:8px;cursor:pointer;font-size:14px;">
          Обновить страницу
        </button>
      </div>
    `;
  }
}

bootstrap();
